/* ==========================================================================
   VT SIZE CHART
   Injects a "Size guide" trigger next to the theme's size option and opens a
   modal where the shopper picks a size and adds to cart.

   It never edits, replaces or removes any existing element or listener.
   Add to cart goes through Shopify's own /cart/add.js, so the theme's
   product form, variant picker and checkout are untouched.
   ========================================================================== */
(function () {
  'use strict';

  function qs(root, sel) { try { return root.querySelector(sel); } catch (e) { return null; } }
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  /* Canonical size key so 2XL and XXL, 3XL and XXXL, "Large" and "L" all match.
     Used ONLY for size comparison; other options still compare literally. */
  var WORDS = {
    'extrasmall': 'xs', 'extralarge': 'xl',
    'small': 's', 'medium': 'm', 'large': 'l',
    'freesize': 'free', 'onesize': 'free', 'standard': 'free'
  };

  function canon(s) {
    var t = norm(s).replace(/[\s._\-\/]+/g, '');
    if (WORDS[t]) return WORDS[t];

    // 2xl -> xxl, 3xl -> xxxl, 2xs -> xxs ...
    var m = t.match(/^(\d{1,2})x(l|s)$/);
    if (m) {
      var n = parseInt(m[1], 10);
      if (n > 0 && n < 10) {
        var out = '';
        for (var i = 0; i < n; i++) out += 'x';
        return out + m[2];
      }
    }
    return t;
  }
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return (fmt || '{{amount}}').replace('{{amount}}', v);
  }

  function SizeChart(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId || '';
    this.optionName = root.dataset.optionName || 'Size';
    this.optionIndex = parseInt(root.dataset.optionIndex, 10);
    this.afterAdd = root.dataset.afterAdd || 'cart';
    this.triggerText = root.dataset.triggerText || 'Size guide';
    this.triggerPos = root.dataset.triggerPos || 'inline';
    this.showIcon = root.dataset.triggerIcon === 'true';
    this.moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    this.cartUrl = root.dataset.cartUrl || '/cart';
    this.unavailableMode = root.dataset.unavailable || 'strike';

    this.modal = qs(root, '[data-vt-sc-modal]');
    this.table = qs(root, '[data-vt-sc-table]');
    this.atc = qs(root, '[data-vt-sc-atc]');
    this.msg = qs(root, '[data-vt-sc-msg]');
    this.priceEl = qs(root, '[data-vt-sc-price]');

    this.variants = [];
    try {
      var tag = qs(root, '[data-vt-sc-variants]');
      if (tag) this.variants = JSON.parse(tag.textContent) || [];
    } catch (e) { this.variants = []; }

    this.selectedSize = null;
    this.lastFocus = null;

    if (isNaN(this.optionIndex) || this.optionIndex < 0) return;

    this.injectTrigger();
    this.bind();
  }

  /* ---------- Find the theme's size option and add the trigger ---------- */

  SizeChart.prototype.findSizeFieldset = function () {
    var scope = document.getElementById('MainProduct-' + this.sectionId) || document;
    var picker = scope.querySelector('variant-selects') || document.querySelector('variant-selects');
    if (!picker) return null;

    var groups = picker.querySelectorAll('.product-form__input');
    var want = norm(this.optionName);

    for (var i = 0; i < groups.length; i++) {
      var head = groups[i].querySelector('legend, label');
      if (!head) continue;
      var txt = norm(head.textContent).replace(/:.*$/, '');
      if (txt === want || txt.indexOf(want) === 0) {
        return { group: groups[i], head: head };
      }
    }
    return null;
  };

  SizeChart.prototype.buildTrigger = function (inline) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vt-sc-trigger' + (inline ? '' : ' vt-sc-trigger--block');
    b.setAttribute('data-vt-sc-open', '');
    if (this.showIcon) {
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
        '<path d="M3 9.5 9.5 3 21 14.5 14.5 21z"/><path d="M8 8.5 9.8 10.3"/>' +
        '<path d="M11 11.5l1.8 1.8"/><path d="M14 14.5l1.8 1.8"/></svg>';
    }
    b.appendChild(document.createTextNode(this.triggerText));
    return b;
  };

  SizeChart.prototype.injectTrigger = function () {
    var found = this.findSizeFieldset();
    var self = this;

    if (found && this.triggerPos === 'inline') {
      found.head.classList.add('vt-sc-legend-flex');
      found.head.appendChild(this.buildTrigger(true));
    } else if (found) {
      found.group.appendChild(this.buildTrigger(false));
    } else {
      var host = qs(this.root, '[data-vt-sc-fallback]');
      if (host) host.appendChild(this.buildTrigger(false));
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-vt-sc-open]') : null;
      if (t) { e.preventDefault(); self.open(); }
    });
  };

  /* ---------- Current state read from the theme, never written to ---------- */

  SizeChart.prototype.currentVariant = function () {
    var scope = document.getElementById('MainProduct-' + this.sectionId) || document;
    var input = scope.querySelector('.product-variant-id') || document.querySelector('.product-variant-id');
    var id = input ? parseInt(input.value, 10) : NaN;
    for (var i = 0; i < this.variants.length; i++) {
      if (this.variants[i].id === id) return this.variants[i];
    }
    return this.variants[0] || null;
  };

  SizeChart.prototype.matchFor = function (sizeValue) {
    var cur = this.currentVariant();
    var idx = this.optionIndex;
    var exact = null;
    var loose = null;

    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      if (canon(v.options[idx]) !== canon(sizeValue)) continue;
      if (!loose) loose = v;
      if (!cur) { exact = v; break; }

      var same = true;
      for (var o = 0; o < v.options.length; o++) {
        if (o === idx) continue;
        if (norm(v.options[o]) !== norm(cur.options[o])) { same = false; break; }
      }
      if (same) { exact = v; break; }
    }
    return exact || loose;
  };

  /* ---------- Render ---------- */

  SizeChart.prototype.refresh = function () {
    if (!this.table) return;
    var rows = this.table.querySelectorAll('[data-vt-sc-row]');
    var self = this;
    var firstAvailable = null;

    Array.prototype.forEach.call(rows, function (tr) {
      var size = tr.getAttribute('data-vt-sc-row');
      var v = self.matchFor(size);
      var ok = !!(v && v.available);

      tr.classList.toggle('is-out', !ok);
      if (!ok && self.unavailableMode === 'hide') {
        tr.style.display = 'none';
      } else {
        tr.style.display = '';
      }
      if (ok && !firstAvailable) firstAvailable = size;
      tr.classList.toggle('is-selected', canon(size) === canon(self.selectedSize || ''));
    });

    if (!this.selectedSize || !this.matchFor(this.selectedSize) || !this.matchFor(this.selectedSize).available) {
      var cur = this.currentVariant();
      var pick = cur && cur.available ? cur.options[this.optionIndex] : firstAvailable;
      this.select(pick, true);
      return;
    }

    this.updatePrice();
    if (this.atc) this.atc.disabled = !this.selectedSize;
  };

  SizeChart.prototype.updatePrice = function () {
    if (!this.priceEl) return;
    var v = this.selectedSize ? this.matchFor(this.selectedSize) : this.currentVariant();
    if (v) this.priceEl.textContent = money(v.price, this.moneyFormat);
  };

  SizeChart.prototype.select = function (size, quiet) {
    this.selectedSize = size || null;
    if (this.msg) this.msg.textContent = '';

    if (this.table) {
      var rows = this.table.querySelectorAll('[data-vt-sc-row]');
      for (var i = 0; i < rows.length; i++) {
        rows[i].classList.toggle('is-selected', canon(rows[i].getAttribute('data-vt-sc-row')) === canon(size || ''));
      }
    }
    this.updatePrice();
    if (this.atc) this.atc.disabled = !this.selectedSize;
    if (!quiet) { /* nothing else to do */ }
  };

  SizeChart.prototype.setUnit = function (unit) {
    var cells = this.root.querySelectorAll('[data-cm]');
    for (var i = 0; i < cells.length; i++) {
      cells[i].textContent = unit === 'cm' ? cells[i].getAttribute('data-cm') : cells[i].getAttribute('data-in');
    }
    var btns = this.root.querySelectorAll('[data-vt-sc-unit]');
    for (var j = 0; j < btns.length; j++) {
      btns[j].classList.toggle('is-active', btns[j].getAttribute('data-vt-sc-unit') === unit);
    }
  };

  /* ---------- Open / close ---------- */

  SizeChart.prototype.open = function () {
    if (!this.modal) return;
    this.lastFocus = document.activeElement;
    this.refresh();
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = qs(this.modal, '[data-vt-sc-close]');
    if (close) close.focus();
  };

  SizeChart.prototype.close = function () {
    if (!this.modal) return;
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ---------- Add to cart ---------- */

  SizeChart.prototype.add = function () {
    var self = this;
    if (!this.selectedSize) return;
    var v = this.matchFor(this.selectedSize);
    if (!v || !v.available) {
      if (this.msg) this.msg.textContent = 'That size is sold out.';
      return;
    }

    var qty = 1;
    var scope = document.getElementById('MainProduct-' + this.sectionId) || document;
    var qtyInput = scope.querySelector('input[name="quantity"]');
    if (qtyInput && parseInt(qtyInput.value, 10) > 0) qty = parseInt(qtyInput.value, 10);

    if (this.atc) { this.atc.classList.add('is-busy'); }
    if (this.msg) this.msg.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (self.atc) self.atc.classList.remove('is-busy');
        if (!res.ok) {
          if (self.msg) self.msg.textContent = (res.data && res.data.description) || 'Could not add to cart.';
          return;
        }
        if (self.afterAdd === 'checkout') {
          window.location.href = '/checkout';
        } else if (self.afterAdd === 'cart') {
          window.location.href = self.cartUrl;
        } else {
          self.close();
          document.dispatchEvent(new CustomEvent('vt:size-chart:added', { detail: res.data }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            fetch('/?sections=cart-drawer').then(function () { drawer.open(); }).catch(function () {});
          } else {
            window.location.href = self.cartUrl;
          }
        }
      })
      .catch(function () {
        if (self.atc) self.atc.classList.remove('is-busy');
        if (self.msg) self.msg.textContent = 'Something went wrong. Please try again.';
      });
  };

  /* ---------- Events ---------- */

  SizeChart.prototype.bind = function () {
    var self = this;

    if (this.modal) {
      this.modal.addEventListener('click', function (e) {
        if (e.target === self.modal) self.close();
        var c = e.target.closest ? e.target.closest('[data-vt-sc-close]') : null;
        if (c) { e.preventDefault(); self.close(); }
        var u = e.target.closest ? e.target.closest('[data-vt-sc-unit]') : null;
        if (u) { e.preventDefault(); self.setUnit(u.getAttribute('data-vt-sc-unit')); }
        var row = e.target.closest ? e.target.closest('[data-vt-sc-row]') : null;
        if (row && !row.classList.contains('is-out')) self.select(row.getAttribute('data-vt-sc-row'));
      });
    }

    if (this.atc) {
      this.atc.addEventListener('click', function (e) { e.preventDefault(); self.add(); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.modal && self.modal.classList.contains('is-open')) self.close();
    });

    // Keep availability in sync when the shopper changes colour on the page
    document.addEventListener('change', function (e) {
      if (!self.modal || !self.modal.classList.contains('is-open')) return;
      if (e.target.closest && e.target.closest('variant-selects')) {
        setTimeout(function () { self.refresh(); }, 60);
      }
    });
  };

  /* ---------- Boot ---------- */

  function init() {
    var roots = document.querySelectorAll('[data-vt-sc-root]:not([data-vt-sc-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-vt-sc-ready', 'true');
      try {
        new SizeChart(roots[i]);
      } catch (e) {
        if (window.console && console.warn) console.warn('[vt-size-chart]', e);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();